import React from 'react';
import Input from '../Common/Input';



const Form = ({ formik }) => {

    return (
        <form onSubmit={formik.handleSubmit}>

            <div className="row">
            <div className="col-md-3" >
                    <Input label="عنوان" name="answerRank" required={true} formik={formik} disabled/>
                </div>
                <div className="col-md-3" >
                    <Input label="وزن" name="andwerPoints" required={true} formik={formik} type="number"/>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12 mt-4 pt-4 text-center">
                    <button className="btn btn-success mx-auto text-center" id="btn-submit-form">ذخیره اطلاعات</button>
                </div>
            </div>

        </form >
    );

}

export default Form;


